import { Logger } from '../../../../common/utils/logger';
import { getIndexedDBOpenOverride } from '../indexed-db-open-override';

export const createIndexedDBPassthrough = async () => {
	const indexedDB = window.indexedDB;

	if (!indexedDB) {
		Logger.warn('No IndexedDB capabilities found');
		return;
	}

	if (typeof indexedDB.open !== 'function') {
		Logger.warn('IndexedDB.open is not a function');
		return;
	}

	try {
		const originalOpen = indexedDB.open.bind(indexedDB);
		
		// Use Object.defineProperty for better browser compatibility and consistency
		// with other passthrough implementations (document.cookie, localStorage/sessionStorage)
		Object.defineProperty(indexedDB, 'open', {
			value: getIndexedDBOpenOverride(originalOpen),
			writable: true,
			configurable: true,
		});
		
		Logger.debug('IndexedDB open override installed');
	} catch (e: any) {
		Logger.error(`Failed to install IndexedDB open override. ${e.message || ''}`);
	}
};
